import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { AppTelemetryService } from './app-telemetry.service';
import { RuntimeHealthService } from './runtime-health.service';

export const GLOBAL_RUNTIME_HEALTH_MESSAGE =
  'An unexpected application issue occurred.';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly injector = inject(Injector);

  handleError(error: unknown): void {
    this.reportRuntimeHealth();
    this.reportTelemetry(error);
  }

  private reportRuntimeHealth(): void {
    try {
      this.injector
        .get(RuntimeHealthService)
        .reportIssue('global', GLOBAL_RUNTIME_HEALTH_MESSAGE);
    } catch {
      // Error handling remains fail-safe when the application injector is unavailable.
    }
  }

  private reportTelemetry(error: unknown): void {
    try {
      this.injector.get(AppTelemetryService).trackError(error);
    } catch {
      // Telemetry failure must not recurse through the global error handler.
    }
  }
}
